import React, { useEffect, useRef, useState } from "react"
import Esign from "../Esign"
import useToggle from "../../../../hooks/toggle";
import { selecteddocumentesign } from "../ReviewDocs";
import { useReactToPrint } from "react-to-print";
import { getexternaldocuments, getSavedOfferDetails, sendagencydisclosure } from "../../../../api/transaction";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { CSpinner } from "@coreui/react";
import { toast } from "react-toastify";
import { notification_success } from "../../../../state/actions";

const ReqAgencyDisclosure = () => {
    const params: { id: any, user: string } = useParams()
    const { id, user } = params
    const [loader,setloading] = useState(false)
    const [agencydis, setAgencyDis] = useState({
        offer_id: id,
        agent_name: "",
        _limited_seller_agent: "",
        _limited_dual_agent: "",
        _limited_buyer_agent: "",
        _customer_only: "",
        _limited_buyer_agent_customer_only: "",
        _limited_seller_agent_customer_only: "",
        _limited_common_law_agent_customer_only: "",
        _common: "",
        common_agent_for_: "",
        buyer_seller: "",
        client1_signature: null,
        client1_signature_date: "",
        client2_signature: null,
        client2_signature_date: "",
        client1_name: "",
        client2_name: "",
        agentname_and_phoneno: "",
        agent_: "",
        init_: "",
        nameof_tm_tl_ph: "",
        nameof_designated_broker: "",
        flat_fee_commission_from_buyer: "",
        flat_fee_commission_from_customer: "",
        client_customer_name: "",
        client_: "",
        date_: ""
    })

    const componentRef = useRef();
    const [canvasmodal, setCanvasModal] = useToggle(false);
    const [htmlContent, setHtmlContent] = useState("");
    const [selecteddocumentesign, setselectedDocumentEsign] = useState<selecteddocumentesign>({
        offerid: "",
        document_name: "",
        image_base64: "",
        sign_role: 1
    })
    const [offerdetails, setOfferDetails] = useState({});
    const printf = () => {
        handlePrint()
    };
    // @ts-ignore
    const val = useSelector((state) => state?.new?.signset)
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });
    const dispatch = useDispatch()

useEffect(()=>{
if(val){
  if(user == "seller"){
    setAgencyDis({ ...agencydis, client1_signature: val }) 
  }
  if(user == "client"){
    setAgencyDis({ ...agencydis, client1_signature: val }) 
  }
}
},[val])

    const send = async (e) => {
   
      // e.preventDefault()
      toast.success("rjf")
      dispatch(notification_success({
         id:id,message:`Invitation already exit.` 
      }))

  setloading(true)
      if(user==="client"){
       
          if (agencydis?.client1_signature) {
              const res = await sendagencydisclosure(agencydis)
              if(res?.status == "success"){
                alert("Submitted Successfully")
            }
            else{
                alert("Something went wrong")
            }
          }
      }
      setloading(false)
      }

    useEffect(() => {
        (async function () {
            let offerdetails = await getSavedOfferDetails(id)
            setOfferDetails(offerdetails[0])
            
        })()

    }, [])


    useEffect(()=>{
      (async function(){
          let offerdetails = await getSavedOfferDetails(id)
          setOfferDetails(offerdetails[0])
        const res =await getexternaldocuments(id,"agencydisclosure") 
        setAgencyDis({...agencydis,
          _limited_seller_agent: res?.data?._limited_seller_agent,
          _limited_dual_agent: res?.data?._limited_dual_agent,
          _customer_only: res?.data?._customer_only,
          _limited_buyer_agent_customer_only: res?.data?._limited_buyer_agent_customer_only,
          _limited_seller_agent_customer_only: res?.data?._limited_seller_agent_customer_only,
          _limited_common_law_agent_customer_only: res?.data?._limited_common_law_agent_customer_only,
          _common: res?.data?._common,
          common_agent_for_: res?.data?.common_agent_for_,
          buyer_seller: res?.data?.buyer_seller,
          client1_signature: res?.data?.client1_signature,
          client1_signature_date: res?.data?.client1_signature_date,
          client2_signature: res?.data?.client2_signature,
          client2_signature_date: res?.data?.client2_signature_date,
          client1_name: res?.data?.client1_name,
          client2_name: res?.data?.client2_name,
          agentname_and_phoneno: res?.data?.agentname_and_phoneno,
          agent_: res?.data?.agent_,
          init_: res?.data?.init_,
          nameof_tm_tl_ph: res?.data?.nameof_tm_tl_ph,
          nameof_designated_broker: res?.data?.nameof_designated_broker,
          flat_fee_commission_from_buyer: res?.data?.flat_fee_commission_from_buyer,
          flat_fee_commission_from_customer: res?.data?.flat_fee_commission_from_customer,
          client_customer_name: res?.data?.client_customer_name,
          client_: res?.data?.client_,
          date_: res?.data?.date_
        })
      })()
    },[])


    return (
        <>
        <div ref={componentRef}>
  <meta charSet="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <link rel="preconnect" href="https://fonts.googleapis.com" />
  <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
  <link
    href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500;1,600&display=swap"
    rel="stylesheet"
  />
  <style
    dangerouslySetInnerHTML={{
      __html:
        '\n        * {\n            font-family: "Poppins", sans-serif;\n        }\n    '
    }}
  />
  <title>Document</title>
  <section style={{ pageBreakAfter: "always", paddingBottom: 50}}>
    <table
      style={{ width: 1100, margin: "0 auto", background: "#fff", padding: "20px" }}
    >
      <tbody>
        <tr>
          <td>
            <table style={{ width: "100%" }}>
              <tbody>
                <tr>
                  <td style={{ width: "90%" }}>
                    <img
                      style={{ width: 250 }}
                      src="https://storagemilforddev.blob.core.windows.net/images/logo.svg"
                    />
                  </td>
                  <td>
                    <img
                      style={{ width: '40px', marginRight: '15px' }}
                      src="https://storagemilforddev.blob.core.windows.net/images/realtor.svg"
                      alt=""
                    />
                    <img
                      style={{ width: 50 }}
                      src="https://storagemilforddev.blob.core.windows.net/images/eh.svg"
                      alt=""
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "15px 0px" }}>
            <span style={{ fontSize: 20, fontWeight: 700, color: '#000' }}>
              Agency Disclosure Information for Buyers and Sellers
            </span>
          </td>
        </tr>
        <tr>
          <td>
            <table style={{ width: "100%" }}>
              <tbody>
                <tr>
                  <td>
                    <span>
                      Company :{" "}
                      <span style={{ color: "#3b0083", fontWeight: 500 }}>
                        Milford Real State
                      </span>
                    </span>
                  </td>
                  <td align="right">
                    <span>
                      Agent Name : 
                      <input
                        type="text" /* @ts-ignore */
                        value={offerdetails?.agentName}
                        // onChange={(e)=>setAgencyDis({...agencydis,agent_name:e.target.value})}
                        style={{
                          outline: "none",
                          border: "none",
                          borderBottom: "1px solid black",
                          width: "350px"
                        }}
                      />
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "15px 0px" }}>
            <span>
              Nebraska law requires all real estate licensees provide this
              information outlining the types of real estate services being
              offered. For additional information on Agency Disclosure and more
              go to:{" "}
              <span style={{ color: "#3b0083", fontWeight: 600 }}>
                http://www.nrec.ne.gov/consumer-info/index.html
              </span>{" "}
              <span style={{ fontWeight: 700 }}>
                The agency relationship offered is (initial one of the boxes
                below, all parties initial if applicable):
              </span>
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ border: "1px solid #3b0083", padding: 10 }}>
            <span style={{ color: "#3b0083", fontWeight: 700 }}>
              <input
                type="text"/* @ts-ignore */
                value={offerdetails?.leadName}
                // onChange={(e)=>setAgencyDis({...agencydis,_limited_buyer_agent:e.target.value})}

                style={{
                  outline: "none",
                  border: "none",
                  borderBottom: "1px solid black"
                }}
              />
              Limited Buyer Agent
            </span>
            <ul style={{ padding: 20 }}>
              <li> Works for the seller</li>
              <li>
                {" "}
                Shall not disclose any confidential information about the seller
                unless required by law
              </li>
              <li>
                {" "}
                May be required to disclose to a buyer otherwise undisclosed
                adverse material facts about the property
              </li>
              <li>
                {" "}
                Must present all written offers to and from the seller in a
                timely manner
              </li>
              <li>
                {" "}
                Must exercise reasonable skill and care for the seller and
                promote the seller’s interests
              </li>
            </ul>
            <span style={{ color: "#3b0083" }}>
              A written agreement is required to create a seller’s
              <span style={{ textDecoration: "underline" }}>
                agency relationship
              </span>{" "}
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "15px 0px 0px 0px" }}>
            <span>
              <input
                type="text"
                style={{
                  outline: "none",
                  border: "none",
                  borderBottom: "1px solid black",
                  width: 50
                }}
              />
              Common Law Agent for
              <input
                type="text"
                style={{
                  outline: "none",
                  border: "none",
                  borderBottom: "1px solid black",
                  width: 50
                }}
              />
              Buyer
              <input
                type="text"
                style={{
                  outline: "none",
                  border: "none",
                  borderBottom: "1px solid black",
                  width: 50
                }}
              />
              Seller (complete and attach Common Law Agency addendum)
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "15px 0px 0px" }}>
            <span style={{ fontWeight: 600, color: "#3b0083" }}>
              This is <u>not</u> a contract and <u>does not</u> create any financial
              obligations.{" "}
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "0px 0px 15px" }}>
            By signing below, I acknowledge that I have received the information
            contained in this agency disclosure and that it was given to me at
            the earliest practicable opportunity during or following the first
            substantial contact with me and, further, if applicable, as a
            customer, the licensee indicated on this form has provided me with a
            list of tasks the licensee may perform for me.
          </td>
        </tr>
        <tr>
          <td style={{ padding: "30px 0px 15px 0px" }}>
            <span style={{ fontSize: 20, fontWeight: 600, color: "#000" }}>
              Acknowledgement of Disclosure
            </span>
          </td>
        </tr> 
        <tr>
          <td style={{ padding: "15px 0px" }}>
            <table style={{ width: "100%" }}>
              <tbody>
                <tr>
                  <td>
                    <img
              
                    src={user === "client" ? (val || agencydis?.client1_signature) : agencydis?.client1_signature}
                      style={{
                        outline: "none",
                        border: "none",
                        borderBottom: "1px solid black",
                      }}
                    />
                    <br />
                    Client or Customer Signature)
                  </td>
                  <td>
                    <input type="date" 
                      value={agencydis?.client1_signature_date ? agencydis?.client1_signature_date : (user === "client" && val || agencydis?.client1_signature) ? new Date().toISOString().split('T')[0] : ""}
                      // value={"2000-01-01"}
                      onChange={(e)=>setAgencyDis({...agencydis,client1_signature_date:e.target.value})}
                    />
                    <br />
                    Date
                  </td>
                  <td>
                    <img
                      src={agencydis?.client2_signature ? agencydis?.client2_signature: ""}
                      
                      style={{
                        outline: "none",
                        border: "none",
                        borderBottom: "1px solid black"
                      }}
                    />
                    <br />
                    Client or Customer Signature)
                  </td>
                  <td>
                    <input type="date" 
                     value={agencydis?.client2_signature_date ? agencydis?.client2_signature_date : new Date().toISOString().split('T')[0]}
                     onChange={(e)=>setAgencyDis({...agencydis,client2_signature_date:e.target.value})}
     
                    />
                    <br />
                    Date
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "15px 0px" }}>
            <table style={{ width: "100%" }}>
              <tbody>
                <tr>
                  <td>
                    <input
                      type="text"/* @ts-ignore */
                      value={offerdetails?.leadName}
                      // onChange={(e)=>setAgencyDis({...agencydis,client1_name:e.target.value})}
                      style={{
                        outline: "none",
                        border: "none",
                        borderBottom: "1px solid black",
                        width: "90%"
                      }}
                    />
                    <br />
                    (Print Client or Customer Name)
                  </td>
                  <td>
                    <input
                      type="text"
                      value={agencydis?.client2_name}
                      onChange={(e)=>setAgencyDis({...agencydis,client2_name:e.target.value})}
                      style={{
                        outline: "none",
                        border: "none",
                        borderBottom: "1px solid black",
                        width: "90%"
                      }}
                    />
                    <br />
                    (Print Client or Customer Name)
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  </section>
  <section style={{ pageBreakAfter: "always", paddingBottom: 50}}>
    <table
      style={{ width: 1100, margin: "0 auto", background: "#fff", padding: 20 }}
    >
      <tbody>
        <tr>
          <td style={{ padding: "15px 0px" }}>
            <table style={{ width: "100%" }}>
              <tbody>
                <tr>
                  <td style={{ width: "90%" }}>
                    <img
                      style={{ width: 250 }}
                      src="https://storagemilforddev.blob.core.windows.net/images/logo.svg"
                    />
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: "15px 0px" }}>
                    <span style={{ fontSize: 20, fontWeight: 700 }}>
                      Contact Information:
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr style={{ padding: "15px 0px" }}>
          <td>1. Agent(s) name(s) and phone number(s)</td>
        </tr>
        <tr>
          <td style={{ paddingLeft: 10 }}>
            <input
              type="text"/* @ts-ignore */
              value={agencydis?.agentname_and_phoneno || offerdetails?.agentName}
              onChange={(e)=>setAgencyDis({...agencydis,agentname_and_phoneno:e.target.value})}
              style={{
                outline: "none",
                border: "none",
                borderBottom: "1px solid black",
                width: "100%"
              }}
            />
          </td>
        </tr>
        <tr>
          <td style={{ paddingLeft: 10 }}>
            <input
              type="text"/* @ts-ignore */
              value={agencydis?.agentname_and_phoneno || offerdetails?.coAgentName}
              onChange={(e)=>setAgencyDis({...agencydis,agentname_and_phoneno:e.target.value})}
              style={{
                outline: "none",
                border: "none",
                borderBottom: "1px solid black",
                width: "100%"
              }}
            />
          </td>
        </tr>
        <tr>
          <td style={{ paddingLeft: 10 }}>
            Only the agent(s) named in #1 (above) is offering to represent you
            as your agent. Other licensees of the same brokerage or members of
            the same team may work for another party to the transaction and
            should NOT be assumed to be your agent. Init. Init. (this paragraph
            is not applicable if the proposed agency relationship is a customer
            only or the brokerage does not practice designated agency)
          </td>
        </tr>
       
        <tr>
          <td style={{ paddingLeft: 10 }}>
            <input
              type="text"
              value={agencydis?.nameof_tm_tl_ph}
              onChange={(e)=>setAgencyDis({...agencydis,nameof_tm_tl_ph:e.target.value})}
              style={{
                outline: "none",
                border: "none",
                borderBottom: "1px solid black",
                width: "100%"
              }}
            />
          </td>
        </tr>
        <tr>
          <td style={{ padding: "15px 0px" }}>
            2. Managing Broker(s) name(s) and phone number(s) (only if
            applicable):{" "}
            <span style={{ color: "#3b0083" }}>
              Karie Milford, 402-880-0202
            </span>
          </td>
        </tr>
      
     
        <tr>
          <td style={{ padding: "15px 0px" }}>
            <span style={{ fontSize: 20, fontWeight: 600 }}>
              Agency Disclosure Information for Buyers and Sellers (continued)
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ fontWeight: 600, padding: "15px 0px" }}>
            Limited Buyer’s Agent Disclosure Information (continued from page 1)
          </td>
        </tr>
        <tr>
          <td style={{ padding: "15px 0px" }}>
            At closing Milford Real Estate collects a flat fee commission of $
            <input
              type="text"/* @ts-ignore */
              value={offerdetails?.broker_admin_fees}
              // onChange={(e)=>setAgencyDis({...agencydis,flat_fee_commission_from_buyer:e.target.value})}
              style={{
                outline: "none",
                border: "none",
                borderBottom: "1px solid black",
                width: 100
              }}
            />
            from Buyers, except as otherwise specified in a written agreement or
            affected by lender requirements.
          </td>
        </tr>
        <tr>
          <td style={{ fontWeight: 600, padding: "15px 0px" }}>
            List of Tasks Agent May Perform for a Customer:
          </td>
        </tr>
        <tr>
          <td style={{ padding: "15px 0px" }}>
            <ul>
              <li>Explain the home buying / selling process</li>
              <li>
                {" "}
                Prepare purchase agreement / Review and explain clauses in the
                offer
              </li>
              <li> Present offers / counter-offers</li>
              <li>
                {" "}
                Provide follow-up services, including coordinating inspections,
                appraisals, surveys, delivering documents and copies
              </li>
            </ul>
          </td>
        </tr>

        <tr>
          <td style={{ padding: "100px 0px" }}>
            Client or Customer name(s):
            <input
              type="text"/* @ts-ignore */
              value={offerdetails?.leadName}
              // onChange={(e)=>setAgencyDis({...agencydis,client_customer_name:e.target.value})}
              style={{
                outline: "none",
                border: "none",
                borderBottom: "1px solid black",
                width: "75%"
              }}
            />
          </td>
        </tr>
      </tbody>
    </table>
  </section>
  <section>
    <table
      style={{ width: 1100, margin: "0 auto", background: "#fff", padding: 20 }}
    >
      <tbody>
        <tr>
          <td>
            <table style={{ width: "100%" }}>
              <tbody>
                <tr>
                  <td style={{ width: "90%" }}>
                    <img
                      style={{ width: 250 }}
                      src="https://storagemilforddev.blob.core.windows.net/images/logo.svg"
                    />
                  </td>
                  <td>
                    <img
                      style={{ width: 40, marginRight: 15 }}
                      src="https://storagemilforddev.blob.core.windows.net/images/realtor.svg"
                      alt=""
                    />
                    <img
                      style={{ width: 50 }}
                      src="https://storagemilforddev.blob.core.windows.net/images/eh.svg"
                      alt=""
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "15px 0px" }}>
            <span style={{ fontSize: 20, fontWeight: 700 }}>
              Affiliated Business Arrangement Disclosure | Trusted Vendor
              Partner
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "15px 0px" }}>
            Client:
            <input
              type="text"
              value={agencydis?.client_}
              onChange={(e)=>setAgencyDis({...agencydis,client_:e.target.value})}
              style={{
                outline: "none",
                border: "none",
                borderBottom: "1px solid black",
                width: "50%"
              }}
            />
          </td>
        </tr>
        <tr>
          <td style={{ padding: "15px 0px" }}>
            <span>
              From:<span style={{ fontWeight: 700 }}> Milford Real Estate</span>
            </span>
          </td>
        </tr>
        <tr>
          <td style={{ padding: "15px 0px" }}>
            Date:
            <input
              type="date"
              value={ agencydis?.date_ ? agencydis?.date_ : new Date().toISOString().split('T')[0]}
              onChange={(e)=>setAgencyDis({...agencydis,date_:e.target.value})}
              style={{
                outline: "none",
                border: "none",
                borderBottom: "1px solid black",
                width: "50%"
              }}
            />
          </td>
        </tr>
        <tr>
          <td style={{ padding: "15px 0px" }}>
            We do mass advertising and/or refer these vendors/services, due to
            good feedback we have received on their services. We are not
            affiliated with any of these vendors other than Milford Closing,
            Milford Marketing, and Milford Select.{" "}
          </td>
        </tr>
        <tr>
          <td style={{ padding: "15px 0px" }}>
            This is to give you notice that Milford Real Estate has mass
            advertising relationships with companies listed below where by
            Milford Real Estate provides referral services to local companies in
            the area to provide name recognition to the general public for
            compensation or we are providing them as a referral based on good
            client services. You are not obligated to use any of these companies
            or services. These companies may include, but are not limited to,
            Mortgage Lenders, Home Inspection Companies, Pest Inspection
            Companies, Moving Companies, Alarm and Security Companies,
            Landscapers, etc. Those companies are listed here:
          </td>
        </tr>
        <tr>
          <td style={{ fontStyle: "italic", paddingLeft: 20 }}>
            Milford Closing, Milford Marketing, Milford Select, Caliber Home
            Loans - Greg Dawes, Caliber Home Loans - Josh Hahn, CMG Financial -
            Jeremy Straatmann, CMG Financial - Trey Jordan, Benchmark Mortgage -
            Eric Almquist, Washington Flooring, Nebraska Title, National
            Property Inspections, Jaffery Insurance, Home Buyers Protection
            Company, Radon Pros, Home Warranty of America, Everlast Exteriors
          </td>
        </tr>
        <tr>
          <td style={{ padding: "15px 0px" }}>
            Federal Unfair Deceptive Abusive Acts or Practices (UDAAP) law
            and/or state law and regulations may require that we provide you
            with this written disclosure statement. You are NOT required to use
            any of these companies. THERE ARE FREQUENTLY OTHER LOCAL VENDORS
            AVAILABLE WITH SIMILAR SERVICES. YOU ARE FREE TO SHOP AROUND TO
            DETERMINE THAT YOU ARE RECEIVING THE BEST SERVICES AND THE BEST RATE
            FOR THESE SERVICES.
          </td>
        </tr>
        <tr>
          <td style={{ fontWeight: 700, padding: "30px 0px" }}>
            ACKNOWLEDGMENT:{" "}
          </td>
        </tr>
        <tr>
          <td>
            I/we have read this disclosure form and understand that the
            Affiliated Companies may refer me/us to purchase the above-described
            service(s) from one another and that any such referrals may provide
            the referring company, its affiliates, and/or their employees and
            agents with a financial or other benefit. I/we give permission to
            give my contact information to the above vendors.
          </td>
        </tr>
        <tr>
          <td style={{ padding: "15px 0px" }}>
            <table style={{ width: "100%" }}>
              <tbody>
                <tr>
                  <td>
                  <img id="seller1_value" src={user === "client" ? (val || agencydis?.client1_signature) : agencydis?.client1_signature}
                                            className='text_input_soil_add' />
                    <br />
                    Client Signature
                  </td>
                  <td>
                    <input type="date"
                     value={agencydis?.client1_signature_date ? agencydis?.client1_signature_date : (user === "client" && val || agencydis?.client1_signature) ? new Date().toISOString().split('T')[0] : ""}
                     onChange={(e)=>setAgencyDis({...agencydis,client1_signature_date:e.target.value})}
                    />
                    <br />
                    date
                  </td>
                  <td>
                    <input
                      type="text"
                      style={{
                        outline: "none",
                        border: "none",
                        borderBottom: "1px solid black",
                        width: 250
                      }}
                    />
                    <br />
                    Client Signature
                  </td>
                  <td>
                    <input type="date" 
                    value={new Date().toISOString().split('T')[0]}
                    />
                    <br />
                    date
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  </section>
</div>

            <React.Fragment>
                <div className="d-flex align-items-center justify-content-end mb-2 mr-2">
                    <button onClick={send} className="btn primaryColorBtn">Submit
                    {loader && <CSpinner color="dark" size="sm" className={'ml-1'} />}
                    </button>
                    <button onClick={printf} className="btn print-doc-btn mx-2">Print</button>
                    <button className="signaturebtn btn mb-0" onClick={() => setCanvasModal()}>Signature</button>
                </div>
            </React.Fragment>

            <Esign
                canvasmodal={canvasmodal}
                setCanvasModal={setCanvasModal}
                htmlContent={htmlContent}
                setHtmlContent={setHtmlContent}
                selecteddocumentesign={selecteddocumentesign}
                setselectedDocumentEsign={setselectedDocumentEsign}
                type={"seller"}
            ></Esign>
        </>
    )
}

export default ReqAgencyDisclosure